import { get, ref } from "firebase/database";
import { database } from "../../../../Utils/firebase";

const GetAssignerUserItemData = async (state, dispatch, sharedBusinesses = null) => {
    const owners = sharedBusinesses || state?.ASSIGNERUSERBUSINESSES || [];

    if (!owners.length) return [];

    try {
        const sharedItems = [];
        const itemMap = new Map();

        const ownerPromises = owners.map(async (owner) => {
            const ownerUid = owner.ownerUid;
            const companies = owner.companies || [];

            // Gather all allowed company IDs for this specific owner
            const allowedCompanyIds = companies.map(company => company.companyId || company.businessId || company.id);

            if (!allowedCompanyIds.length) return;

            const itemRef = ref(database, `invoiceGenerator/users/${ownerUid}/items`);
            const snapshot = await get(itemRef);

            if (!snapshot.exists()) return;

            const data = snapshot.val();

            Object.entries(data).forEach(([id, info]) => {
                if (!info || !info.name) return;

                // STRICT LOCAL FILTER: ensure item belongs to a shared company
                // If item has a companyId, check it. If it doesn't, include it as a 'global' item for this owner.
                if (!info.companyId || allowedCompanyIds.includes(info.companyId)) {
                    
                    const price = (parseFloat(info.defaultPrice) || 0).toFixed(2);
                    const key = `${info.itemId}-${info.name}-${price}-${ownerUid}`; // Ensure unique across shared admins

                    if (!itemMap.has(key)) {
                        itemMap.set(key, {
                            companyId: info.companyId,
                            name: info.name,
                            price: price,
                            date: info.createdDate || info.date || "",
                            subtitle: info.subtitle || "",
                            itemId: info?.itemId || "",
                            isShared: true,
                            ownerUid: ownerUid
                        });
                    }
                }
            });
        });

        await Promise.all(ownerPromises);

        return Array.from(itemMap.values());

    } catch (error) {
        console.error("Firebase AssignerUser Item Fetch Error:", error);
        return [];
    }
};

export default GetAssignerUserItemData;
